export default __webpack_public_path__ + "static/media/female.ddd97151.PNG";